<template>
  <div style="overflow-x:hidden ">
    <NavHeader
      :status="{
        page:'produceChemistry',
        produce:true,
        solution:false
      }"
    />
    <div class="main">
      <div class="first-title"></div>


      <div class="first-content">
        <div class="first-back-left"></div>
        <div class="first-back-right"></div>
        <div class="first-content-card">
          <div class="card-left" >
            <div class="card-left-content" style="margin-top: 2vw"  @click="changeRight('line1','实验室制取氧气的方法','初中化学四大基本反应类型之分解反应：实验室制取氧气的方法','/截图/化学/氧气.png')">
              <div class="change-line line1" ></div>
              <div class="card-left-content-text">分解反应</div>
            </div>
            <div class="card-left-content"   @click="changeRight('line2','铁丝在氧气中的燃烧现象','初中化学四大基本反应类型之化合反应：铁丝在氧气中的燃烧现象','/截图/化学/铁丝在空气和氧气中燃烧.png')">
              <div class="change-line line2" ></div>
              <div class="card-left-content-text">化合反应</div>
            </div>
            <div class="card-left-content"  @click="changeRight('line3','金属与某些金属化合物溶液的反应','初中化学四大基本反应类型之置换反应：金属与某些金属化合物溶液的反应','/截图/化学/金属的物理性质.png')">
              <div class="change-line line3" ></div>
              <div class="card-left-content-text">置换反应</div>
            </div>
            <div class="card-left-content"   @click="changeRight('line4','氢氧化钠溶液与硫酸铜溶液的反应','初中化学四大基本反应类型之复分解反应：氢氧化钠溶液与硫酸铜溶液的反应','/截图/化学/氢氧化钠溶液与硫酸铜溶液反应-2.png')">
              <div class="change-line line4" ></div>
              <div class="card-left-content-text">复分解反应</div>
            </div>
          </div>
          <div class="card-right">
            <div class="card-right-title">
              <i class="el-icon-d-arrow-right" style="font-weight: 1000"></i><span>{{title}}</span>
            </div>
            <div class="card-right-text">
              {{text}}
            </div>
            <div class="card-right-pic">

              <div class="math-1" v-if="title==='实验室制取氧气的方法'">

              </div>
              <div class="math-2" v-if="title==='铁丝在氧气中的燃烧现象'">

              </div>
              <div class="math-3" v-if="title==='金属与某些金属化合物溶液的反应'">
                <div class="math-3-1"></div>
                <div class="math-3-2"></div>
              </div>
              <div class="math-4" v-if="title==='氢氧化钠溶液与硫酸铜溶液的反应'">
              </div>
            </div>
            <div class="card-right-webgl">
              <img  :src="'http://data.xiyilab.com/web/main/static'+pic_uri" style="width: 100%">
            </div>
          </div>
        </div>
      </div>

      <div class="second-card">
        <div class="second-title"></div>
        <div class="second-right-in"></div>
        <div class="second-left-in"></div>
        <div class="second-card-content">
          <div class="round round-1" >
            <div class="line-1">
              <div class="point" ></div>
              <div class="line-1-line-1" ></div>
              <div class="line-1-line-2" ></div>
            </div>
            <div class="text-1" >贴合教材</div>
            <div class="line-2">
              <div class="point" ></div>
              <div class="line-2-line-1" ></div>
            </div>
            <div class="text-2" >资源丰富</div>
            <div class="text-3" >科学严谨</div>
            <div class="line-3">
              <div class="point" ></div>
              <div class="line-3-line-1" ></div>
            </div>
            <div class="round-under">资源方面</div>
          </div>
          <div class="round round-2">
            <div class="line-1">
              <div class="point"></div>
              <div class="line-1-line-1"></div>
              <div class="line-1-line-2"></div>
            </div>
            <div class="text-1">真实还原</div>
            <div class="line-2">
              <div class="point"></div>
              <div class="line-2-line-1"></div>
            </div>
            <div class="text-2">便于理解</div>
            <div class="text-3">加深记忆</div>
            <div class="line-3">
              <div class="point"></div>
              <div class="line-3-line-1"></div>
            </div>
            <div class="round-under">呈现方面</div>
          </div>
          <div class="round round-3">
            <div class="round-under">功能方面</div>
            <div class="line-1">
              <div class="point"></div>
              <div class="line-1-line-1"></div>
              <div class="line-1-line-2"></div>
            </div>
            <div class="text-1">智能指导</div>
            <div class="line-2">
              <div class="point"></div>
              <div class="line-2-line-1"></div>
            </div>
            <div class="text-2">评分系统</div>
            <div class="text-3">成绩分析</div>
            <div class="line-3">
              <div class="point"></div>
              <div class="line-3-line-1"></div>
            </div>
          </div>
          <div class="round round-4">
            <div class="round-under">操作方面</div>
            <div class="line-1">
              <div class="point"></div>
              <div class="line-1-line-1"></div>
              <div class="line-1-line-2"></div>
            </div>
            <div class="text-1">安装便捷</div>
            <div class="line-2">
              <div class="point"></div>
              <div class="line-2-line-1"></div>
            </div>
            <div class="text-2">使用方便</div>
            <div class="text-3">多平台适配</div>
            <div class="line-3">
              <div class="point"></div>
              <div class="line-3-line-1"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="third-card">
        <div class="third-title"></div>
        <div class="third-content">
          <div class="switch-btn"  @click="switchCaseCard('left')">
            <i class="el-icon-back"></i>
          </div>
          <div class="switch-zone">
            <div class="third-content-card-0">
              <div style="width: 100%;height: 100%;border: 2px white solid">
                
                  <vue-plyr >
                    <video
                      :controls="false"
                      src="https://data.xiyilab.com/apps/webgl/同步实验/人教版/化学/金属与盐酸、稀硫酸的反应（探究）/preview.mp4">
                      <track kind="captions"
                             label="Chinese"
                             srclang="en"
                             default />
                    </video>
                  </vue-plyr>
                
              </div>
            </div>
            <div class="third-content-card-1">
              <div style="width: 100%;height: 100%;border: 2px white solid">
                
                  <vue-plyr >
                    <video
                      :controls="false"
                      src="https://data.xiyilab.com/apps/webgl/同步实验/人教版/化学/配置两种不同溶液浓度的氯化钠溶液/preview.mp4">
                      <track kind="captions"
                             label="Chinese"
                             srclang="en"
                             default />
                    </video>
                  </vue-plyr>
                
              </div>
            </div>
            <div class="third-content-card-2">
              <div style="width: 100%;height: 100%;border: 2px white solid">
                
                  <vue-plyr >
                    <video
                      :controls="false"
                      src="https://data.xiyilab.com/apps/webgl/同步实验/人教版/化学/水的沸腾/preview.mp4">
                      <track kind="captions"
                             label="Chinese"
                             srclang="en"
                             default />
                    </video>
                  </vue-plyr>
                
              </div>
            </div>
            <div class="third-content-card-3">
              <div style="width: 100%;height: 100%;border: 2px white solid">
                
                  <vue-plyr >
                    <video
                      :controls="false"
                      src="https://data.xiyilab.com/apps/webgl/同步实验/人教版/化学/配置两种不同溶液浓度的氯化钠溶液/preview.mp4">
                      <track kind="captions"
                             label="Chinese"
                             srclang="en"
                             default />
                    </video>
                  </vue-plyr>
                
              </div>
            </div>
            <div class="third-content-card-4">
              <div style="width: 100%;height: 100%;border: 2px white solid">
                
                  <vue-plyr >
                    <video
                      :controls="false"
                      src="https://data.xiyilab.com/apps/webgl/同步实验/人教版/化学/金属与盐酸、稀硫酸的反应（探究）/preview.mp4">
                      <track kind="captions"
                             label="Chinese"
                             srclang="en"
                             default />
                    </video>
                  </vue-plyr>
                
              </div>
            </div>
          </div>
          <div class="switch-btn" @click="switchCaseCard('right')">
            <i class="el-icon-right"></i>
          </div>
        </div>
        <div class="more-btn">查看更多</div>
      </div>

      <div class="footer-img">
        <div style="font-family: test;font-size: 1.2vw;color: white;font-weight: 100;cursor: default">让我们一起育见未来</div>
        <div class="footer-btn-group">
          <div class="footer-btn">立即试用</div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import NavHeader from '@/components/NavHeader'
import Footer from '@/components/Footer'
import $ from 'jquery'
export default {
  name: 'produceChemistry',
  components:{
    NavHeader,
    Footer
  },
  data(){
    return{
      activeLine:'line1',
      rightFlag:0,
      leftFlag:0,
      title:'实验室制取氧气的方法',
      aboveCard:2,
      openDate:'',
      pic_uri:'/截图/化学/氧气.png',
      freshWebGL:true,
      webglOptions:{
        app_uri:'https://data.xiyilab.com/apps/webgl/同步实验/人教版/化学/加热高锰酸钾制取氧气/Build/加热高锰酸钾制取氧气.json',
        subject:'化学',
        platform:'webgl',
        mode:0,
        url:'https://api.xiyilab.com/v1',
        publisher:'人教版',
        grade:'八年级',
        chapter:'第一章',
        app_info_img_url:'https://data.xiyilab.com/',
        app_id:0,
        app_platform_id:'1'
      },
      text:'初中化学四大基本反应类型之分解反应：实验室制取氧气的方法'
    }
  },
  mounted () {
    $('.'+this.activeLine).animate({
      width:'5vw'
    },300)
    $('.first-back-right').animate({
      bottom:(Math.random()*(2-2) + 2).toFixed(2)+'vw',
      right:(Math.random()*(12-12) + 12).toFixed(1)+'vw'
    },2000)
    $('.first-back-right').animate({
      bottom:'2vw',
      right:'10vw'
    },2000)
    $('.first-back-left').animate({
      top:(Math.random()*(1-2) + 3).toFixed(2)+'vw',
      left:(Math.random()*(12-14) + 14).toFixed(2)+'vw'
    },1500)
    $('.first-back-left').animate({
      top:'3vw',
      left:'13vw'
    },1500)
    this.timer1=setInterval(()=>{
      $('.first-back-left').animate({
        top:(Math.random()*(1-2) + 3).toFixed(2)+'vw',
        left:(Math.random()*(12-14) + 14).toFixed(2)+'vw'
      },1500)
      $('.first-back-left').animate({
        top:'3vw',
        left:'13vw'
      },1500)
    },3000)
    this.timer=setInterval(()=>{
      let date=new Date()
      $('.first-back-right').animate({
        bottom:(Math.random(date)*(2-2) + 2).toFixed(2)+'vw',
        right:(Math.random(date)*(12-12) + 12).toFixed(1)+'vw'
      },2000)
      $('.first-back-right').animate({
        bottom:'2vw',
        right:'10vw'
      },2000)

    },4000)
    window.addEventListener('mousewheel',(e)=>{
      // if(e.pageY>1500){
      //   this.showToTop=true
      // }
      // else {
      //   this.showToTop = false
      // }
      this.openDate=new Date()
      if($('.second-left-in')[0].getBoundingClientRect().top-window.innerHeight<=0&&this.rightFlag===0){
        $('.second-left-in').animate({
          left:'-1vw'
        },500)
        this.rightFlag=1
      }
      if($('.second-right-in')[0].getBoundingClientRect().top-window.innerHeight<=0&&this.leftFlag===0){
        $('.second-right-in').animate({
          right:'0'
        },500)
        this.leftFlag=1
      }
    })
  },
  methods:{
    switchCaseCard(position){

      let now=new Date()


      if(now-this.openDate>500){
        console.log(1)
        if(position==='left'){
          $('.third-content-card-'+(this.aboveCard+3)%5).animate({
            width:'40vw',
            height:'23vw',
            top:'5vw',
            left:'23vw',
            zIndex:'1'
          },300)
          $('.third-content-card-'+(this.aboveCard+4)%5).animate({
            width:'40vw',
            height:'23vw',
            top:'5vw',
            left:'1vw',
            zIndex:'1'
          },300)
          $('.third-content-card-'+(this.aboveCard)%5).animate({
            width:'50vw',
            height:'28vw',
            top:'2.5vw',
            left:'2vw',
            zIndex:'10'
          },300)
          $('.third-content-card-'+(this.aboveCard+1)%5).animate({
            width:'58vw',
            height:'33vw',
            top:'0',
            left:'3vw',
            zIndex:'999'
          },300)
          $('.third-content-card-'+(this.aboveCard+2)%5).animate({
            width:'50vw',
            height:'28vw',
            top:'2.5vw',
            left:'12vw',
            zIndex:'10'
          },300)



          this.aboveCard=(this.aboveCard+1)%5
        }
        else{
          $('.third-content-card-'+(this.aboveCard+2)%5).animate({
            width:'40vw',
            height:'23vw',
            top:'5vw',
            left:'1vw',
            zIndex:'1'
          },300)
          $('.third-content-card-'+(this.aboveCard+1)%5).animate({
            width:'40vw',
            height:'23vw',
            top:'5vw',
            left:'23vw',
            zIndex:'1'
          },300)
          $('.third-content-card-'+(this.aboveCard)%5).animate({
            width:'50vw',
            height:'28vw',
            top:'2.5vw',
            left:'12vw',
            zIndex:'10'
          },300)
          $('.third-content-card-'+(this.aboveCard+4)%5).animate({

            width:'58vw',
            height:'33vw',
            top:'0',
            left:'3vw',
            zIndex:'999'
          },300)
          $('.third-content-card-'+(this.aboveCard+3)%5).animate({
            width:'50vw',
            height:'28vw',
            top:'2.5vw',
            left:'2vw',
            zIndex:'10'
          },300)


          this.aboveCard=(this.aboveCard+4)%5
        }
        this.openDate=now

      }
    },
    changeRight(text,title,content,url){

      this.title=title
      this.text=content
      this.freshWebGL=false
      this.pic_uri=url
      setTimeout(()=>{
        this.freshWebGL=true
      },500)
      $('.'+this.activeLine).animate({
        width:'0.3vw'
      },300)
      $('.'+text).animate({
        width:'5vw'
      },300)
      this.activeLine=text

    }
  }
}
</script>

<style scoped>
.math-1{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/分解反应.png");
  width: 20vw;
  height: 1.2vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
}
.math-2{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化合反应.png");
  width: 20vw;
  height: 1.2vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
}
.math-3{

  width: 80%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 1.2vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
}
.math-3-1{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/置换反应1.png");
  width: 20vw;
  height: 1.2vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
  margin-right: 2vw;
}
.math-3-2{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/置换反应2.png");
  width: 15vw;
  height: 1vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
}
.math-4{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/复分解反应.png");
  width: 20vw;
  height: 1.2vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
}
.header {
  position: relative;
  width: 100vw;
  height: 42vh;
}
.main{
  margin-top: 22vw;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.first-title{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学四大模块.png");
  margin-top: 2vw;
  margin-bottom: 2vw;
  width: 20vw;
  height: 3.5vw;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.first-content{
  height: 43vw;
  width: 100vw;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.first-back-right{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学模考装饰背景右侧.png");
  width: 332px;
  height: 340px;
  position: absolute;
  bottom:2vw;
  right:10vw;
  z-index: -1;
}
.first-back-left{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学模考装饰背景左侧.png");
  width: 442px;
  height: 415px;
  position: absolute;
  top:3vw;
  left:13vw;
  z-index: -1;
}
.first-content-card{
  width: 70vw;
  height: 40vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  position: absolute;
  z-index: 999;
}
.card-left{
  width: 20%;
  height: 100%;
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学模块导航.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.card-right{
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
  justify-content: flex-start;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.card-right-webgl{
  width: 90%;
  height: 80%;
  margin-left: 2.3vw;
  object-fit: cover;
  margin-top: 1vw ;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.card-right-text{
  width: 90%;
  margin-left: 2.3vw;
  line-height: 2vw;
  font-family: test;
  margin-top: 0.5vw;
  max-height: 4vw;
  font-size: 0.8vw;
  font-weight: 100;
  letter-spacing: 1px;
  white-space: normal;
}
.card-right-pic{
  height: 2vw;
  width: 90%;
  margin-left: 2.3vw;
  line-height: 2vw;
  font-family: test;
  margin-top: 0.5vw;
  max-height: 4vw;
  font-size: 0.8vw;
  font-weight: 100;
  letter-spacing: 1px;
  white-space: normal;
}
.card-right-title{
  white-space: nowrap;
  position: relative;
  width: 20rem;
  height: 2vw;
  line-height: 2vw;
  margin-left: 2vw;
  margin-top: 1vw;
  font-size: 1.2vw;
  font-weight: 800;
  letter-spacing: 1px;

}

.card-right-title i {

  -webkit-background-clip: text;
  color: transparent;
}
.card-right-title span {
  background-image: linear-gradient(90deg,
  rgba(250, 209, 38, 1) 0%,
  #ff544f 100%);
  -webkit-background-clip: text;
  color: transparent;

}
.card-left-content{
  height: 2.5vw;
  margin-top:0;
  margin-bottom: 0;
  margin-left: 1vw;
  color: white;
  font-weight: 800;
  font-family: test;
  font-size: 0.8vw;
  letter-spacing: 1px;
  line-height: 2.5vw;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  white-space: nowrap;
  cursor: pointer;
}
.change-line{
  width: 0.3vw;
  height: 0.3vw;
  background-color: white;
  margin: 0 1vw 0;
}
.second-card{
  width: 100vw;
  height: 35vw;
  background-color: white;
  margin-top: 5vw;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  flex-direction: column;
}
.second-card-content{
  width: 60vw;
  height: 20vw;
  margin-top: 2vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}

.round{
  width: 10vw;
  height: 100%;

  background-size: 6vw 6vw;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  font-family: test;
  font-size: 0.8vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 18px;
  letter-spacing: 2px;
  color: #3e3a39;
  transition: all .3s;
}
.round:hover{
  background-size: 6vw 6vw;
}
.round:hover .point{
  display: inline-block;
}
.round:hover .line-1-line-1{
  width: 2.5vw;
}
.round:hover .text-1{
  display: inline-block;
}
.round:hover .text-2{
  display: inline-block;
}
.round:hover .text-3{
  display: inline-block;
}
.round:hover .line-1-line-2{
  width: 30px;
}
.round:hover .line-2-line-1{
  width: 2.5vw;
}
.round:hover .line-3-line-1{
  width: 3vw;
}
.line-1{
  position: absolute;
  top:7.8vw;
  right:3vw;
  transition: all .3s;
}
.point{
  display: none;
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgb(247,210,131);
  transition: all .3s;
}
.line-1-line-1{
  position: absolute;
  top:3px;
  width: 0;
  height: 2px ;
  background-color: rgb(247,210,131);
  transition: all .3s;
  transform:rotate(180deg);
  -o-transform: rotate(180deg);
  -webkit-transform:rotate(180deg); /* Chrome and Safari */
  -moz-transform:rotate(180deg); /* Firefox */
}
.line-1-line-2{
  position: absolute;
  top:10px;
  left:2.4vw;
  width: 0;
  height: 2px ;
  background-color: rgb(247,210,131);
  transform:rotate(30deg);
  -o-transform: rotate(30deg);
  -webkit-transform:rotate(30deg); /* Chrome and Safari */
  -moz-transform:rotate(30deg); /* Firefox */
  transition-delay: .3s;
  transition: all .3s;
}
.text-1{
  display: none;
  position: absolute;
  width: 4vw;
  height: 0.8vw;
  white-space: nowrap;
  text-align: center;
  top:9vw;
  right:-4vw;
  transition: all .3s;
  font-weight: 800;
  font-size: 0.9vw;
}
.line-2{
  position: absolute;
  top:11.8vw;
  left:2.5vw;
  transition: all .3s;
}
.line-2-line-1{
  position: absolute;
  top:3px;
  left:-2.5vw;
  width: 0;
  height: 2px ;
  background-color: rgb(247,210,131);
  transition: all .3s;
}
.text-2{
  position: absolute;
  top:11.5vw;
  left:-4.3vw;
  transition: all .3s;
  display: none;
  font-weight: 800;
  font-size: 0.9vw;
}
.text-3{
  position: absolute;
  top:5vw;
  left:-3.4vw;
  transition: all .3s;
  display: none;
  font-weight: 800;
  font-size: 0.9vw;
}
.line-3{
  position: absolute;
  top:7.5vw;
  left: 3vw;
  transition: all .3s;
}
.line-3-line-1{
  position: absolute;
  width: 0;
  top:-0.7vw;
  left:-2.7vw;
  height: 2px ;
  background-color: rgb(247,210,131);
  transform:rotate(30deg);
  -o-transform: rotate(30deg);
  -webkit-transform:rotate(30deg); /* Chrome and Safari */
  -moz-transform:rotate(30deg); /* Firefox */
  transition: all .3s;
}
.round-1{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学特色1.png");
}
.round-2{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学特色2.png");
}
.round-3{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学特色3.png");
}
.round-4{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学特色4.png");
}
.second-left-in{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学装饰1.png");
  left: -20vw;

  z-index: 999;
  position: absolute;
  width: 12vw;
  height: 18vw;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.second-right-in{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学装饰2.png");
  right:-20vw;
  bottom: 2vw;
  z-index: 999;
  position: absolute;
  width: 14vw;
  height: 12vw;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.second-title{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学产品特色.png");
  margin-top: 2vw;
  margin-bottom: 2vw;
  width: 19vw;
  height: 3.5vw;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.third-card{
  width: 100vw;
  background-color: rgb(249,250,255);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  flex-direction: column;
}
.more-btn{
  height: 1.8vw;
  line-height: 1.8vw;
  width: 6vw;
  font-size: 0.8vw;
  font-family: test;
  font-weight: normal;
  background-image: linear-gradient(90deg,
  rgba(250, 209, 38, 1) 0%,
  #ff544f 100%),
  linear-gradient(
    #000000,
    #000000);
  background-blend-mode: normal,
  normal;
  border-radius: 1.8vw;
  color: white;
  text-align: center;
  margin-bottom: 5vw;
}
.third-title{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学内置资源.png");
  margin-top: 3vw;
  margin-bottom: 3vw;
  width: 19vw;
  height: 3.5vw;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.third-content{
  height: 33vw;
  width: 75vw;
  margin: 0 auto 2vw;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.switch-btn{
  position: relative;
  width: 2vw;
  height: 2vw;
  line-height: 180px;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
  background-image: linear-gradient(90deg,
  rgba(250, 209, 38, 1) 0%,
  #ff544f 100%);
}
.switch-btn i{
  color: white;
  position: absolute;
  font-size: 1vw;
  top:0.5vw;
  left: 0.5vw;
}
.switch-btn:after{
  position: absolute;
  content: '';
  background-image: linear-gradient(90deg,
  rgba(250, 209, 38, 1) 0%,
  #ff544f 100%);
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  z-index: -1;
  transform: scale(1.05);
  border-radius: 50%;
}
.switch-btn:hover{
  background-image: linear-gradient(90deg,
  rgba(250, 209, 38, 1) 0%,
  #ff544f 100%),
  linear-gradient(
    #5c6c7a,
    #5c6c7a);
  background-blend-mode: normal,
  normal;
  box-shadow: 0px 26px 57px 0px
  rgba(247, 210, 131, 0.4);
  border: solid 1px #f0f3fd;
}
.switch-btn:hover i{
  color: white;
}
.switch-zone{
  width: 64vw;
  height: 33vw;
  position: relative;
  overflow: hidden;
}
.third-content-card-0{
  position: absolute;
  left: 1vw;
  top:5vw;
  width: 40vw;
  height: 23vw;
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.third-content-card-1{
  position: absolute;
  left: 2vw;
  top:2.5vw;
  width: 50vw;
  height: 28vw;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.third-content-card-2{
  position: absolute;
  left: 3vw;
  width: 58vw;
  height: 33vw;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.third-content-card-3{
  position: absolute;
  left:12vw;
  top:2.5vw;
  width: 50vw;
  height: 28vw;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.third-content-card-4{
  position: absolute;
  left: 23vw;
  top:5vw;
  width: 40vw;
  height: 23vw;
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.footer-img{
  width: 100vw;
  height: 9vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/化学底部.png");
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer-btn-group{
  margin-top: 2vw;
  width: 30vw;
  height: 1.8vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
}
.footer-btn{
  width: 6vw;
  font-weight: 100;
  font-size: 0.8vw;
  font-family: test;
  border: 1px white solid;
  color: white;
  background: transparent;
  line-height:1.8vw;
  text-align: center;
  cursor: pointer;
}
.round-under{
  position: absolute;
  width: 6vw;
  height: 2vw;
  text-align: center;
  line-height: 2vw;
  font-size: 0.85vw;
  font-family: test;
  border-radius: 4px;
  color: white;
  background-image: linear-gradient(90deg,
  rgba(250, 209, 38, 1) 0%,
  #ff544f 100%),
  linear-gradient(
    #000000,
    #000000);
  background-blend-mode: normal,
  normal;
  left:2vw;
  bottom:2vw;
}
</style>
